import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { usePostStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function PostGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid />
}

export default function PostGridLayout() {
  return <GridProvider store={usePostStore()}>
    <PostGrid />
  </GridProvider>
}
